import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Modal } from 'bootstrap';
import { debounceTime, skip } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ReportsService } from 'src/app/services/reports.service';
import { ToastService } from 'src/app/toast/toast.service';


export function allotmentGreaterThanLiftedValidator(): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const allotment = group.get('allotment')?.value;
    const lifted = group.get('lifted')?.value;

    if (allotment != null && lifted != null && +lifted > +allotment) {
      return { liftedGreaterThanAllotment: true };
    }

    return null;
  };
}

@Component({
  selector: 'app-pds-stock-lifting',
  templateUrl: './pds-stock-lifting.component.html',
  styleUrls: ['./pds-stock-lifting.component.scss']
})
export class PdsStockLiftingComponent {

  UserDetails: any;
  targetForm!: FormGroup;
  blockList: any[] = [];
  financialYears: any[] = [];
  stockLiftingList: any[] = [];
  circlesList: any[] = [];
  consumerGoodsForm!: FormGroup;
  stockLiftingForm!: FormGroup;

  rows: any[] = [];
  months: any[] = [];
  showButton = false
  currentMonth: any = {};
  monthKeyMap: Record<number, string> = {
    1: 'april',
    2: 'may',
    3: 'june',
    4: 'july',
    5: 'august',
    6: 'september',
    7: 'october',
    8: 'november',
    9: 'december',
    10: 'january',
    11: 'february',
    12: 'march'
  };
  constructor(private reportService: ReportsService,private authService: AuthService, private fb: FormBuilder, private toastService: ToastService) {

  }

  ngOnInit(): void {

    this.targetForm = this.fb.group({
      financialYear: ['', Validators.required],
      blockOffice: ['', Validators.required],

    });


    let user: any = this.authService.currentUserValue;
    this.UserDetails = user;

    // switch (this.UserDetails?.roleId) {
    //   case 13:
    //     this.targetForm.addControl('blockOffice', new FormControl(['', Validators.required]))
    //     // this.targetForm.get('blockOffice')?.valueChanges
    //     //   .pipe(skip(1)) // ignore the first emit
    //     //   .subscribe((val: any) => {
    //     //     if (this.targetForm.valid) {

    //     //     }
    //     //   });
    //     break;
    //   case 1:
    //     this.targetForm.get('circleOffice')?.valueChanges
    //       .pipe(skip(1)) // ignore the first emit
    //       .subscribe((val: any) => {
    //         if (this.targetForm.valid) {

    //         }
    //       });
    //     break;
    //   case 11:
    //     this.targetForm.addControl('blockOffice', new FormControl([Validators.required]))
    //     this.targetForm.controls['blockOffice'].disable();
    //     break;
    //   default:
    // }


    const today = new Date();
    const currentMonthYear = today.toISOString().slice(0, 7); // format: "2025-09"

    // In your component.ts (e.g., ngOnInit or constructor)
    this.stockLiftingForm = this.fb.group({
      financialYear: [{ value: '2025-26', disabled: true }],
      blockOffice: [{ value: 'Shimla Urban - Block Office', disabled: true }],
      dataMonth: [{ value: 'June, 2025', disabled: true }],

      totalFPS: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
      fpsNotLifted: ['', [Validators.required, Validators.pattern(/^\d+$/)]],

      items: this.fb.array([
        this.fb.group({
          itemName: ['Pulses'],
          allotment: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          lifted: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          unit: ['Qtls.']
        }, { validators: [allotmentGreaterThanLiftedValidator()] }),
        this.fb.group({
          itemName: ['Salt'],
          allotment: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          lifted: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          unit: ['Qtls.']
        }, { validators: [allotmentGreaterThanLiftedValidator()] }),
        this.fb.group({
          itemName: ['Oil (Refined & Mustard)'],
          allotment: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          lifted: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
          unit: ['Ltrs.']
        }, { validators: [allotmentGreaterThanLiftedValidator()] }),
      ]),

      liftingPercentage: [{ value: '', disabled: true }],
      reason: ['']
    });

    this.stockLiftingForm.get('items')?.valueChanges.subscribe(() => {
      this.calculateLiftingPercentage();
    });



    switch (this.UserDetails?.roleId) {
      case 13:

        break;
      case 1:
        this.targetForm.addControl('circleOffice', new FormControl({
          value: '',
          disabled: false
        }, Validators.required));
        this.getCircle();
        break;
      case 11:
        this.targetForm.controls['blockOffice'].disable();


        break;
      default:
    }
    this.GetYearAndMonth();
    this.getTargetCount();
    this.targetForm.valueChanges
      .pipe(debounceTime(300))  // waits 300ms after last change
      .subscribe(values => {
        if (this.targetForm.valid) {
          this.GetPDSStockLifting();
        }
      });

  }

  // Getter to access items as FormArray
  get items(): FormArray {
    return this.stockLiftingForm.get('items') as FormArray;
  }

  calculateLiftingPercentage(): void {
    const items = this.stockLiftingForm.get('items') as FormArray;
    let totalAllotment = 0;
    let totalLifted = 0;

    items.controls.forEach(group => {
      const allotment = parseFloat(group.get('allotment')?.value) || 0;
      const lifted = parseFloat(group.get('lifted')?.value) || 0;

      totalAllotment += allotment;
      totalLifted += lifted;
    });

    const percentage = totalAllotment > 0
      ? ((totalLifted / totalAllotment) * 100).toFixed(2)
      : '0.00';

    this.stockLiftingForm.get('liftingPercentage')?.setValue(percentage, { emitEvent: false });
  }

  getTargetCount() {
    let obj = {
      // "action": "GetBIDropdownValue",
      "action": (this.UserDetails?.roleId == 1) ? "GetARDropdownValue" : "GetBIDropdownValue",
      "circleId": this.UserDetails?.iCircleId
    }
    this.reportService.GetTargetCount(obj).subscribe(res => {
      if (res) {
        // this.circlesList = res.data.circles;
        if (this.UserDetails?.roleId !== 1) {
          this.blockList = res.data.blocks;
        }

        this.financialYears = res.data.financialYears
        if (this.UserDetails?.roleId == 11) {
          this.targetForm.controls['blockOffice'].setValue(this.UserDetails?.iBlockId);
          this.targetForm.controls['blockOffice'].disable();
        }
      }
    },
      (error: any) => {
      }
    );
  }
  getCircle() {

    this.reportService.getCircle().subscribe((res: any) => {
      if (res) {
        // this.circlesList = res.data.circles;
        this.circlesList = res.data.circles;
      }
    },
      (error: any) => {
      }
    );
  }

  GetBlock() {


    let obj = {
      // "action": "GetBIDropdownValue",
      "blockId": 0,
      "circleId": this.targetForm.value?.circleOffice
      // "circleId": 0
    }


    this.reportService.GetBlock(obj).subscribe((res: any) => {
      if (res) {

        this.blockList = res.data?.block;
        this.targetForm.controls['blockOffice'].setValue('');

      }
    },
      (error: any) => {
      }
    );
  }
  GetYearAndMonth() {

    this.reportService.GetYearAndMonth({}).subscribe((res: any) => {
      if (res) {
        //  this.financialYears = res.data.financialYears
        this.months = res.data.months


      }
    },
      (error: any) => {
      }
    );
  }
  GetPDSStockLifting() {
    let obj = {
      blockId: this.targetForm.getRawValue().blockOffice.toString(),
      "financialYear": this.targetForm.value?.financialYear?.financialYear
    }
    this.reportService.GetPDSStockLifting(obj).subscribe((res: any) => {

      if (res && res?.data && res?.data.length > 0) {

        let lastRow = res?.data[res?.data.length - 1];

        this.stockLiftingList = res?.data
        if (Number(lastRow?.dataMonth) != 12 && Number(lastRow?.dataMonth) < 12) {
          let fyear = this.targetForm.getRawValue()?.financialYear.financialYear
          let year = (Number(lastRow?.dataMonth) <= 9) ? fyear?.split('-')[0] : fyear.split('-')[1]
          this.currentMonth.key = (Number(lastRow?.dataMonth) + 1).toString();
          this.currentMonth.name = this.monthKeyMap[(Number(lastRow?.dataMonth) + 1)] + ', ' + year
          this.showButton = true
        } else {
          this.showButton = false

        }


      } else {

        this.showButton = true;
        this.currentMonth.name = this.monthKeyMap['1'] + ', ' + this.targetForm.value?.financialYear?.startYear
        this.currentMonth.key = '1';
        this.toastService.showInfo('NO Data Found!')
        this.stockLiftingList = []
      }
    },
      (error: any) => {
      }
    );
  }

  addData() {
    this.stockLiftingForm.patchValue({
      financialYear: this.targetForm.value?.financialYear,
      blockOffice: this.targetForm.getRawValue()?.blockOffice,
      dataMonth: this.currentMonth.key
    });
  }


  onSubmit() {
    if (this.stockLiftingForm.valid) {


      const formValue = this.stockLiftingForm.getRawValue();

      const payload = {

        financialYear: formValue.financialYear?.financialYear, // string
        dataMonth: formValue.dataMonth, // you should implement this
        blockOffice: formValue.blockOffice, // you should implement this
        totalFPS: +formValue.totalFPS,
        noOfFPSWhoDidNotLift: +formValue.fpsNotLifted,
        allotmentPulses: +formValue.items[0]?.allotment || 0,
        liftingPulses: +formValue.items[0]?.lifted || 0,
        allotmentSalt: +formValue.items[1]?.allotment || 0,
        liftingSalt: +formValue.items[1]?.lifted || 0,
        allotmentOil: +formValue.items[2]?.allotment || 0,
        liftingOil: +formValue.items[2]?.lifted || 0,
        percentageOfLifting: +formValue.liftingPercentage || 0,
        reasonForNotLifting: formValue.reason || '',


        "createdBy": this.edit ? 0 : this.UserDetails?.id,
        "modifiedBy": this.edit ? this.UserDetails?.id : 0,
        id: this.edit ? this.editId : 0
      };



      this.reportService.AddPDSStockLifting(payload).subscribe((res: any) => {
        if (res) {

          if (res?.status == 200) {
            this.toastService.showSuccess(res.message);

            this.hideModal('LiftingPulsesUnderPDSModal');
            this.stockLiftingForm.reset();
            this.stockLiftingForm.markAsUntouched();
            this.GetPDSStockLifting();
            this.edit = false
            this.editId = 0;
          } else {
            this.toastService.showError(res.message);
          }

        }

      },
        (error: any) => {
        }
      );


    } else {
      this.stockLiftingForm.markAllAsTouched();
    }
  }

  edit = false;
  editId = 0


  openModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.show();

    }
  }

  hideModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.hide();
    }
  }


  editRow(row: any) {

    const data = row;
    const headerData = this.targetForm.getRawValue();
    //  Update form values
    this.stockLiftingForm.patchValue({
      financialYear: headerData.financialYear,
      blockOffice: data?.blockOffice, // You may map ID to name here
      dataMonth: data.dataMonth,

      totalFPS: data.totalFPS,
      fpsNotLifted: data.noOfFPSWhoDidNotLift,

      liftingPercentage: data.percentageOfLifting,
      reason: data.reasonForNotLifting,
    });

    // Update items FormArray
    const itemsArray = this.stockLiftingForm.get('items') as FormArray;
    if (itemsArray && itemsArray.length >= 3) {
      itemsArray.at(0).patchValue({
        allotment: data.allotmentPulses,
        lifted: data.liftingPulses
      });
      itemsArray.at(1).patchValue({
        allotment: data.allotmentSalt,
        lifted: data.liftingSalt
      });
      itemsArray.at(2).patchValue({
        allotment: data.allotmentOil,
        lifted: data.liftingOil
      });
    }



    this.editId = data?.id
    this.edit = true

    this.openModal('LiftingPulsesUnderPDSModal');
  }
  allowOnlyInteger(event: any, maxLength: number) {
    let input = event.target.value;

    input = input.replace(/\D/g, '');

    input = input.replace(/^0+/, '');

    if (input === '0') {
      input = '';
    }

    if (input.length > maxLength) {
      input = input.substring(0, maxLength);
    }

    event.target.value = input;
  }

  closeModel() {
    // this.stockLiftingForm.reset()
    this.stockLiftingForm.markAsUntouched()
    this.editId = 0
    this.edit = false
  }

  DeletePDSStockLifting(id: any) {
    this.reportService.DeletePDSStockLifting(id).subscribe((res: any) => {
      if (res) {

        if (res?.status == 200) {
          this.toastService.showSuccess(res.message);
          this.deleteIndex = 0;
          // this.hideModal();
          this.GetPDSStockLifting();
        }

      }
    },
      (error: any) => {
      }
    );
  }

  verifyPDSStockLifting(id: any) {
    this.reportService.verifyPDSStockLifting(id).subscribe((res: any) => {
      if (res) {

        if (res?.status == 200) {
          this.toastService.showSuccess(res.message);
          this.deleteIndex = 0;
          // this.hideModal();
          this.GetPDSStockLifting();
        }

      }
    },
      (error: any) => {
      }
    );
  }
  getMonthName(month: string | number): string {
    const months = [
      'April', 'May', 'June', 'July', 'August', 'September',
      'October', 'November', 'December', 'January', 'February', 'March'
    ];
    const index = +month - 1;
    return months[index] || 'Unknown';
  }

  getYearFromFinancialYear(financialYear: string, month: string | number): string {
    const [startYear, endYear] = financialYear.split('-');
    const monthNum = +month;
    return monthNum >= 1 && monthNum <= 9 ? startYear : endYear;
  }


  calculateBalance(row: any): number {
    const start = +row.societyUL || 0;
    const putUL = +row.societyPutUL || 0;
    const woundUp = +row.societyWoundUP || 0;
    const revived = +row.societyRevived || 0;
    return start + putUL - woundUp - revived;
  }

  deleteIndex: any
  setDeleteIndex(index: number) {
    this.deleteIndex = index;
  }
  cancelDelete() {
    this.deleteIndex = 0;

  }

}
